<template>
  <button
    class="btn-copy-link"
    @click="copyLink"
    :class="{'active': active, 'in-form': type=='form'}"
    :title="title"
    type="button"
  >
    <img
      src="/images/design/copy_link.svg"
      alt=""
    >
    <span v-if="type=='form'">{{$t('main.button_copy_link')}}</span>
  </button>
</template>
<script>
export default {
  props: {
    elementId: {
      type: [String, Number],
      required: true,
    },
    groupElement: {
      type: String,
      default: "element",
    },
    type: {
      type: String,
      default: "list",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    link() {
      const origin = window.location.origin;
      return `${origin}/?load_${this.groupElement}_id=${this.elementId}`;
    },
  },
  methods: {
    async copyLink() {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(this.link);
        } else {
          const el = document.createElement("textarea");
          el.value = this.link;
          el.setAttribute("readonly", "");
          el.style.position = "absolute";
          el.style.left = "-9999px";
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
        }

        this.$store.dispatch("notification/add", {
          type: "success",
          message: this.$t("main.copy_link_success"),
        });
        this.active = true;
        setTimeout(() => (this.active = false), 3000);
      } catch (e) {
        this.$store.dispatch("notification/add", {
          type: "error",
          message: this.$t("main.copy_link_error"),
        });
      }
    },
  },
};
</script>
<style scoped>
.btn-copy-link {
  background-color: #cfe2e8;
  width: 38px;
  height: 38px;
  border-radius: 3px;
  transition: all 0.2s;
  padding: 5px;
}
.btn-copy-link.in-form {
  width: auto;
  height: 28px;
  display: flex;
  align-items: center;
  column-gap: 7px;
  font-size: 14px;
  color: #fff;
  padding-left: 10px;
  padding-right: 10px;
}
.btn-copy-link.in-form img {
  width: 18px;
  height: 18px;
}
.btn-copy-link:hover {
  background-color: #a1bbc3;
}
.btn-copy-link:active,
.btn-copy-link.active {
  background-color: #059669;
}
</style>
